// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ClosedCaptionsOverlay_overlay__3vPI_"};